// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layouts-default-body-cbyxi{min-width:1240px}.layouts-default-body-cbyxi a:hover{color:var(--color-primary-hover)}.layouts-default-layout-lhppx{display:flex;flex-direction:column;min-height:100vh;padding-left:50px!important;padding-right:50px!important}.layouts-default-nuxt-bdikf{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"body": "layouts-default-body-cbyxi",
	"layout": "layouts-default-layout-lhppx",
	"nuxt": "layouts-default-nuxt-bdikf"
};
module.exports = ___CSS_LOADER_EXPORT___;
